export const FIELD_GROUP_COORDINATOR_FIELDS = 'coordinator_fields';
export const FIELD_GROUP_ALX_FIELDS = 'alx_fields';
export const FIELD_GROUP_CUSTOM_FIELDS = 'custom_fields';
export const FIELD_GROUP_ORIGINAL_ALX_FIELDS = 'original_alx_fields';
export const FIELD_GROUP_AMENDED_ALX_FIELDS = 'amended_alx_fields';
